import { default as APRMON } from './APRMON';
import { default as BTC } from './BTC';
import { default as ETH } from './ETH';
import { default as MATIC } from './MATIC';
import { default as MON } from './MON';
import { default as SOL } from './SOL';
import { default as USDC } from './USDC';
import { default as USDT } from './USDT';

export default { APRMON, BTC, ETH, MATIC, MON, SOL, USDC, USDT };
